import React, { useEffect } from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';
import StepperComponentInputs from '../../Inputs/StepperComponent.inputs';
import withStepperHOC from '../../services/HOC/withStepperHOC';
import withRouter from '../../services/HOC/withRouterHOC';
import withFormHOC from '../../services/HOC/withFormHOC';
import LoaderComponent from '../../Inputs/LoaderComponent';
import useIBOSignupHook from './components/IBOSignup.hook';
import ShoppingCartComponent from '../../Common/Components/AllFormsCommons/ShoppingCartComponent';
import withMiniCartHOC from '../../services/HOC/withMinCartHOC';
import MainStepperSignUp from '../../Common/Components/AllFormsCommons/MainStepperSignUp';
import LayoutComponent from '../../Layout';
import { storeAssigned } from '../../services/Methods/normalMethods';
import localStorageCall from '../../services/Methods/localstorage.hook';

const SECTION = 'IBO'
const isWebAlias = true;

const IBOSignUp = ({ SIGNUP_TEXT, ...props }) => {
    const { countryCodes, ...others } = useOutletContext();
    const data = useIBOSignupHook(props);
    const navigate = useNavigate();
    useEffect(() => {
        const CUSTOMER_TYPE = localStorageCall().getItem('customerTypeDescr')?.type;
        if ((CUSTOMER_TYPE === 2) && data?.isUserLogin) {
            navigate(`/${storeAssigned()}/shop`)
        }
    }, [])

    return (
        <LayoutComponent  {...{ ...props, ...others }}>
            <div className="container mx-auto max-w-[1260px] px-[15px]">
                {data?.isLoginLoading && <LoaderComponent />}
                <StepperComponentInputs steps={SIGNUP_TEXT?.Register_Steps[data?.FormId]} activeStep={data?.activeStep}>
                    <MainStepperSignUp {...{
                        section: SECTION,
                        cartProducts: props?.addToCartProducts?.IBOProducts,
                        countryCodes,
                        navigate: props?.navigate,
                        isWebAlias, ...data
                    }} />
                </StepperComponentInputs>
                <ShoppingCartComponent
                    section='IBO'
                    _minCartQuantityIncDec={props?._minCartAndViewCartQuantityIncDec}
                    openMiniCart={props?.openMiniCart}
                    setOpenMiniCart={props?.setOpenMiniCart}
                    _deleteProductFromCart={props?._deleteProductFromCart}
                    productData={props?.addToCartProducts?.IBOProducts}
                    activeStep={data?.activeStep}
                    setActiveStep={data?.setActiveStep}
                    _autoShipCheck={props?._autoShipCheck} />
            </div>
        </LayoutComponent>
    );
};
export default withRouter(withStepperHOC(withFormHOC(withMiniCartHOC(IBOSignUp, SECTION))));